import djs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

/**
 * Add plugins to dayjs.
 * @see https://day.js.org/docs/en/installation/installation
 * @see https://day.js.org/docs/en/plugin/utc
 * @see https://day.js.org/docs/en/plugin/timezone
 */
djs.extend(utc);
djs.extend(timezone);

const dayjs = djs;

export default dayjs;
export type { Dayjs } from "dayjs";
